import React, {useEffect} from 'react';
import Tabs from '../../../../components/tabs';
import MeusEventosConstants from '../utils/MeusEventosConstants';
import {Card} from 'primereact/card';
import MeusEventosController from '../controller/meus-eventos.controller';
import MeuEventoCard from '../components/MeuEventoCard';
import {Paginator} from 'primereact/paginator';
import If from '../../../../../vendors/components/If';

export default function MeusEventos() {
  const tabs = MeusEventosConstants.TAB_LISTA;
  const controller = new MeusEventosController();

  useEffect(() => {
    controller.init();
  }, []);

  return (
    <>
      <div className="no-spaces meus-eventos">
        <Card>
          <Tabs
            onClick={(value: any) => controller.changeTab(value)}
            ativo={controller.tab}
            items={tabs}/>
        </Card>
        <div className="wrapper">
          {controller.list.map((m: any, index: any) =>
            <MeuEventoCard evento={m} key={index}/>
          )}
          <If condition={controller.list.length <= 0}>
            <div className="flex justify-content-center" style={{width: '100%', margin: '20px 0'}}>
              <h3 className="text-center">Nenhum registro encontrado</h3>
            </div>
          </If>
        </div>
        <div>
          <Paginator
            rows={controller.lazyParams.rows}
            first={controller.lazyParams.first}
            totalRecords={controller.total}
            onPageChange={(e: any) => controller.onPage(e)}
            rowsPerPageOptions={[6, 12, 18, 24, 30]}
          />
        </div>
      </div>
    </>
  );
}
